import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import IconButton from '../Button/IconButton';
import Flex from '../Flex';

export interface ArrowProps {
    className?: string;
    onClick?: () => void;
}

export const NextArrow = ({ className, onClick }: ArrowProps) => {
    return (
        <Flex className={className} align="center" justify="center" onClick={onClick}>
            <IconButton bgColor={'fillMedium'} color="text" shadow icon={faAngleRight} large />
        </Flex>
    );
};

export const PrevArrow = ({ className, onClick }: ArrowProps) => {
    return (
        <Flex className={className} align="center" justify="center" onClick={onClick}>
            <IconButton bgColor={'fillMedium'} color="text" shadow icon={faAngleLeft} large />
        </Flex>
    );
};

export const NextArrowFrosted = ({ className, onClick }: ArrowProps) => {
    return (
        <Flex className={className} align="center" justify="center" onClick={onClick}>
            <FrostedArrowButton>
                <FontAwesomeIcon icon={faAngleRight} />
            </FrostedArrowButton>
        </Flex>
    );
};

export const PrevArrowFrosted = ({ className, onClick }: ArrowProps) => {
    return (
        <Flex className={className} align="center" justify="center" onClick={onClick}>
            <FrostedArrowButton>
                <FontAwesomeIcon icon={faAngleLeft} />
            </FrostedArrowButton>
        </Flex>
    );
};

const FrostedArrowButton = styled.button`
    width: 40px;
    height: 40px;
    border-radius: 30px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
